import { useState, useEffect } from 'react';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

export const useAdminRole = () => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setRole(userData.role || 'admin_full'); // Par défaut full admin
          }
        } catch (error) {
          console.error('Erreur chargement rôle:', error);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return {
    role,
    loading,
    isFullAdmin: role === 'admin_full',
    isRestrictedAdmin: role === 'admin_restricted'
  };
};